__turbopack_context__.v({
  "button": "NavigationButton-module-scss-module__MTtaSa__button",
  "chevron": "NavigationButton-module-scss-module__MTtaSa__chevron",
  "down": "NavigationButton-module-scss-module__MTtaSa__down",
  "text": "NavigationButton-module-scss-module__MTtaSa__text",
  "up": "NavigationButton-module-scss-module__MTtaSa__up",
});
